import type { GridColDef } from "@mui/x-data-grid-premium";
import { Typography } from "@mui/material";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";
import type { ProductColumns__ItemFragment } from "./productColumns.generated.js";

interface Options {
  headerName: string;
}

export function createProductBrandLineColumn<
  T extends DocDataGrid_ItemFragment & ProductColumns__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "productBrandLine",
    headerName: options.headerName,
    width: 120,
    editable: false,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      const item = params.row.item;
      if (item.type !== "paid" || item.isItemEliminated) return null;
      if (!item.product) return null;
      const brand = item.product.brand;
      // brandLine holds PIM's complete display title (for sub-brand-lines the
      // already-concatenated "<mainBrandLine> <subLine>" form) — render as-is,
      // mainBrandLine is auxiliary metadata and must not be prepended (RF-219).
      const brandLine = item.product.brandLine;
      if (!brand) return null;
      const label = brand && brandLine ? `${brand} / ${brandLine}` : brand;
      return (
        <Typography variant="body2" noWrap>
          {label}
        </Typography>
      );
    },
  };
}
